import { Box, IconButton } from "@mui/joy";

import { useUser } from "../../../../hooks/query";
import { useEffect, useState } from "react";
import { DataGrid } from "../../../../components";

import { columnDef } from "./column-def";
import { Component, Plus } from "lucide-react";
import { Link } from "react-router-dom";

export default function List() {
    const { useList } = useUser();
    const listUserSvc = useList();

    const [users, setUsers] = useState([]);

    const fetchUserData = async () => {
        try {
            const response = await listUserSvc.mutateAsync({});
            setUsers(response);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    return (
        <Box flex={1} height={300}>
            <IconButton
                variant="plain"
                color="neutral"
                size="md"
                sx={{ p: 0, minWidth: 0, color: "black" }}
                component={Link}
                to={'/admin/users/new'}

            >
                <Plus />
            </IconButton>
            <DataGrid gridData={users} autoHeight={true} columnDefs={columnDef} />
        </Box>
    );
}
